<template>
    <ul class="navbar-nav">
        <b-nav-item-dropdown
            :text="label"
            :right="align == 'right'"
            class="custom-select no-padding-vertical form-control"
            no-caret>
            <div class="b-dropdown-searchbox">
                <input v-model="search"
                    v-on:submit="(e) => e.preventDefault()"
                    type="text"
                    class="form-control"
                    placeholder="Search" />
            </div>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item
                    v-if="filteredOptions.length > 0"
                    v-for="option in filteredOptions"
                    v-on:click="updateValue(option)"
                    :class="[option.id == value ? 'active' : '']"
                    :key="option.id"
                    v-html="option.name"
                    ></b-dropdown-item>
                <b-dropdown-header v-else>-- None --</b-dropdown-header>
        </b-nav-item-dropdown>
    </ul>
</template>
<script>
export default {
    data() {
        return {
            search: '',
        }
    },

    props: ['value', 'placeholder', 'options', 'align', 'disabled'],


    computed: {
        label() {
            const value = this.value ? _.chain(this.options).find(({ id }) => id == this.value).get('name').value() : null;
            return value || this.placeholder;
        },
        filteredOptions() {
            return _.values(this.options)
                .filter(option => {
                    let pass = true;

                    // always contain none value
                    if (!option.id) return pass;

                    if (this.search) {
                        pass = _.values(option)
                            .join(' ')
                            .toLowerCase()
                            .indexOf(String(this.search).toLowerCase()) >= 0;
                    }

                    return pass;
                });
        }
    },

    methods: {
        updateValue(value) {
            const id = _.get(value, 'id', value);
            this.$emit('input', id);
            this.$emit('change', value);
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/CustomSelectComponent.vue